(async function () {
  let apiUrl='https://api.apntly.com/appointly'
  let mainJsUrl = 'https://cdn.shopify.com/s/files/1/0561/1280/8096/t/25/assets/appointly-main.js?v=1652810495'
  let isActiveData = (await (await fetch(`${apiUrl}/api/client/isActive`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      clientUniqueId: 'TWF7NLGL9T7AAFM8X8457KAI'
    })
  })).json())
  let isClientActive = isActiveData && (isActiveData.isActive === true);
  if (isClientActive) {
    window.activeServiceProductIds = isActiveData.activeServiceProductIds;
    let mainJsScriptTag = document.createElement('script');
    mainJsScriptTag.src = mainJsUrl;
    mainJsScriptTag.async = true;
    document.getElementsByTagName('head')[0].appendChild(mainJsScriptTag);
  }
})();

